import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGenerativeFillConfig } from '@/data/landingConfig/landingGenerativeFillConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GenerativeFill } from './schemaObject';

interface Props {}
const GenerativeFill: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GenerativeFill} />
			<LandingTemplate
				data={landingGenerativeFillConfig}
				funnelLinkService={GenerateLandingLinkService.funnelGenerativeFill()}
			/>
		</>
	);
};

export default GenerativeFill;
